import * as React from 'react';
import { IMarkupSwitcher } from './markup-switcher.types';

const MarkupSwitcher: React.FC<IMarkupSwitcher> = ({
    shouldInheritStyles,
    defaultBlock,
    inheritBlock
}) => (
    <>{shouldInheritStyles ? inheritBlock : defaultBlock}</>
);

export default MarkupSwitcher;
